// extracted by mini-css-extract-plugin
export var growableInput = "_48-0";
export var tagContainer = "_48-2";
export var textInput = "_48-1";